import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import OrderForm from "../Forms/Order/Order";
import SignupForm from "../Forms/Signup/Client/Signup";

import Signin from "../Modals/Signin";
import Invoice from "../Invoice/Invoice";

import { KeyboardArrowDown, PersonOutline } from "@material-ui/icons";

import Logo from "../../images/logo.svg";

import "./Order.css";

const Order = () => {
  const history = useHistory();
  const uploadQuote = useSelector((state) => state.upload);
  const [showSignup, setShowSignup] = useState(false);
  const [showSignin, setShowSignin] = useState(false);
  const categoryPrice = uploadQuote.price || 4.99;
  const uncountedFiles = uploadQuote.files?.filter(
    (file) => file.count === 0
  ).length;
  const totalPrice =
    uncountedFiles > 0
      ? "NA"
      : (
          categoryPrice *
          uploadQuote.totalCount *
          uploadQuote.languageTo.length
        ).toFixed(2);

  return (
    <div className="order d-flex justify-between">
      <Signin showSignin={showSignin} setShowSignin={setShowSignin} order />
      <div className="order__left pr-40 pb-20">
        <div className="order__top d-flex justify-between align-center py-20">
          <img src={Logo} alt="" onClick={() => history.push("/")} />
          <button
            className="border-1 outline-0 py-10 px-20 rounded pointer"
            onClick={() => history.push("/contact-us")}
          >
            Contact Us
          </button>
        </div>

        <div className="order__bottom">
          {showSignup && (
            <div className="order__info d-flex align-center font-heavy p-20">
              <PersonOutline className="mr-10" />
              Have an account already?{" "}
              <span
                className="pl-5 pointer"
                onClick={() => setShowSignin(true)}
              >
                Sign in
              </span>
            </div>
          )}
          <details className="order__details">
            <summary className="d-flex align-center justify-between list-none w-100 border-1 p-10 mt-10">
              Show order summary
              <KeyboardArrowDown />
            </summary>
            <div>
              <Invoice
                uploadQuote={uploadQuote}
                uncountedFiles={uncountedFiles}
                totalPrice={totalPrice}
                small
              />
            </div>
          </details>
          {showSignup ? (
            <SignupForm
              uploadQuote={uploadQuote}
              setShowSignup={setShowSignup}
              order
            />
          ) : (
            <OrderForm
              setShowSignup={setShowSignup}
              uploadQuote={uploadQuote}
              uncountedFiles={uncountedFiles}
              totalPrice={totalPrice}
              order
            />
          )}
        </div>
      </div>
      <Invoice uploadQuote={uploadQuote} uncountedFiles={uncountedFiles} />
    </div>
  );
};

export default Order;
